import apiClient from '../apiClient';
import { POST_COUNTRY_URL } from '../apiUrl';

const postCountryApi = data => {
  return apiClient.post(POST_COUNTRY_URL, data);
};

export default postCountryApi;
